// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.cosmos.LeasingGetCosmosJourneyTokenWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CosmosGetJourneyTokenResponseDto, LeaseArtifactType } from '../..';

interface GetJourneyTokenParams {
  leaseArtifactId: number;
  leaseArtifactType: LeaseArtifactType;
}
interface GetJourneyTokenFromOuidParams {
  ouid: string;
}

export const LeasingGetCosmosJourneyTokenWebApiHandler_getJourneyToken_Path = '/api/web/v1/cosmos/getJourneyToken';

/**
 * get journey token for lease
 */
export const LeasingGetCosmosJourneyTokenWebApiHandler_getJourneyToken = (
  getParams: GetJourneyTokenParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetJourneyTokenParams, never, CosmosGetJourneyTokenResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingGetCosmosJourneyTokenWebApiHandler_getJourneyToken_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeasingGetCosmosJourneyTokenWebApiHandler_getJourneyTokenFromOuid_Path =
  '/api/web/v1/ouid/getJourneyTokenFromOuid';

/**
 * get journey token for lease from ouid
 */
export const LeasingGetCosmosJourneyTokenWebApiHandler_getJourneyTokenFromOuid = (
  getParams: GetJourneyTokenFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetJourneyTokenFromOuidParams, never, CosmosGetJourneyTokenResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingGetCosmosJourneyTokenWebApiHandler_getJourneyTokenFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
